import AccountDeleteModal from "./accountDeleteModal";

export default AccountDeleteModal;